import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import View from "./pages/View";
import { NotFound } from "./pages/NotFound";
import DrawingPage from "./pages/DrawingPage";
import Start from "./pages/Start";
import Room from "./pages/Room";
import Test from "./pages/Test";

export const RoutesComponent = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate replace to="/Start" />} />
        <Route path="/room" element={<Room />} />
        <Route path="/draw" element={<DrawingPage />} />
        <Route path="/view" element={<View />} />
        <Route path="/start" element={<Start />} />
        <Route path="/test" element={<Test />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

export default RoutesComponent;

